export const environment = {
  production: true,
  // Default SaaS API; overridden at bootstrap from tenant-hosts.ts when hostname matches.
  // No trailing slash — services append `/api/...`.
  apiUrl: 'https://flexibot-backoffice.azurewebsites.net',
  facebook: {
    appId: '1049859520260157',
    configurationId: '1434549161091923'
  }
};
